var _line, _line2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 8.58057,
    x2: 12.5,
    y2: 8.58057,
    stroke: "#777A89",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 15.7686,
    x2: 4.5,
    y2: 15.7686,
    stroke: "#777A89",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.2234C17 18.2234 14 16.5871 14 14.6C14 14.2488 14.1249 13.9084 14.3536 13.6367C14.5822 13.3651 14.9004 13.179 15.2541 13.1101C15.6077 13.0412 15.9749 13.0938 16.2932 13.2589C16.6115 13.424 16.8613 13.6914 17 14.0156C17.1387 13.6914 17.3885 13.424 17.7068 13.2589C18.0251 13.0938 18.3923 13.0412 18.7459 13.1101C19.0996 13.179 19.4178 13.3651 19.6464 13.6367C19.8751 13.9084 20 14.2488 20 14.6C20 16.5871 17 18.2234 17 18.2234Z",
    stroke: "#777A89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.2234C7 11.2234 4 9.58706 4 7.60005C4 7.24878 4.12495 6.90836 4.35359 6.63672C4.58222 6.36507 4.90043 6.17897 5.25406 6.11008C5.60769 6.04119 5.9749 6.09377 6.29322 6.25886C6.61154 6.42396 6.86129 6.69139 7 7.01563C7.13871 6.69139 7.38846 6.42396 7.70678 6.25886C8.0251 6.09377 8.39231 6.04119 8.74594 6.11008C9.09957 6.17897 9.41778 6.36507 9.64641 6.63672C9.87505 6.90836 10 7.24878 10 7.60005C10 9.58706 7 11.2234 7 11.2234Z",
    fill: "white",
    stroke: "#777A89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFilter);
export default __webpack_public_path__ + "static/media/SaveFilter.23419bb3.svg";
export { ForwardRef as ReactComponent };